import { identity } from "deso-protocol";
import { camelCase } from "es-toolkit";

export const getFocusAuthHeaders = (jwt: string, publicKey: string) => {
  return {
    headers: jwt
      ? {
          Authorization: "Bearer " + jwt,
          "Public-Key": publicKey,
        }
      : {
          "Public-Key": publicKey,
        },
  };
};

export const getOptionalFocusAuthHeadersAsync = async (publicKey: string) => {
  let snapshot: Awaited<ReturnType<typeof identity.snapshot>> | null = null;

  try {
    snapshot = await identity.snapshot();
  } catch {
    snapshot = null;
  }

  if (snapshot?.currentUser?.publicKey !== publicKey) {
    return getFocusAuthHeaders("", publicKey);
  }

  let jwt = "";

  try {
    jwt = await identity.jwt();
  } catch {
    jwt = "";
  }

  return getFocusAuthHeaders(jwt, publicKey);
};

export const getFocusAuthHeadersAsync = async (expectedPublicKey?: string) => {
  const [jwt, snapshot] = await Promise.all([
    identity.jwt(),
    identity.snapshot(),
  ]);

  if (!jwt || !snapshot.currentUser?.publicKey) {
    throw new Error("Your session has expired. Please log in again.");
  }

  if (
    expectedPublicKey &&
    snapshot.currentUser.publicKey !== expectedPublicKey
  ) {
    throw new Error(
      "Your authenticated account does not match the active account. Please switch accounts or log in again.",
    );
  }

  return getFocusAuthHeaders(
    jwt,
    expectedPublicKey ?? snapshot.currentUser.publicKey,
  );
};

export const generateRandomId = (prefix: string) => {
  const normalizedFeedName = camelCase(prefix);
  const randomHash = Math.random().toString(36).substring(2, 8); // Generate a pseudo-random string of 6 characters
  return `${normalizedFeedName}${randomHash}`;
};
